import { render, staticRenderFns } from "./SetStatusModalY67T.vue?vue&type=template&id=72052493&scoped=true&"
import script from "./SetStatusModalY67T.vue?vue&type=script&lang=js&"
export * from "./SetStatusModalY67T.vue?vue&type=script&lang=js&"
import style0 from "./SetStatusModalY67T.vue?vue&type=style&index=0&id=72052493&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72052493",
  null
  
)

export default component.exports